// removed by extract-text-webpack-plugin
module.exports = {"cellWidth":"200px","cellHeight":"25px","headerHeight":"60px","employeesHeight":"60px","hoursWidth":"45px","hoursTop":"120px","hoursTopMobile":"60px"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fc16ebb6","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/Organization/Container.vue
// module id = MQu7
// module chunks = 1